/**
 * @generated SignedSource<<0e50e545d6ed47b22ada68ce97bf0ee2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicPageQuery$variables = {
  after?: string | null | undefined;
  applicationId: string;
  count?: number | null | undefined;
  entityId: string;
  superTopicQueueName: string;
};
export type topicPageQuery$data = {
  readonly superTopicQueue: {
    readonly items: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entityUuid?: string;
          readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle" | "homeSecondaryContentItemContent" | "sectionTopLeadPrimaryContentItemContent" | "topStoriesItemContent">;
        };
      }>;
    } | null | undefined;
  } | null | undefined;
  readonly topic: {
    readonly advertZone: string | null | undefined;
    readonly entityId: string;
    readonly entityUuid: string;
    readonly name: string;
    readonly sponsor: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"hooksTopic" | "topicDescriptionTopic" | "topicHeaderTopic" | "topicRestContentsTopic" | "topicSeoTopic" | "topicTopContentsTopic" | "topicTopicPageTopic">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"hooksTopicWidgetQuery">;
};
export type topicPageQuery = {
  response: topicPageQuery$data;
  variables: topicPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityId"
},
v1 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "applicationId"
  },
  {
    "defaultValue": 28,
    "kind": "LocalArgument",
    "name": "count"
  },
  (v0/*: any*/),
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "superTopicQueueName"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "entityId",
    "variableName": "entityId"
  }
],
v3 = [
  {
    "fields": (v2/*: any*/),
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "types",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "kind": "InlineDataFragmentSpread",
  "name": "hooksTopic",
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v6/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "scmp_pwa_settings"
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "json",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "scmp_pwa_advert_campaign"
    }
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "version",
      "value": 2
    }
  ],
  "kind": "ScalarField",
  "name": "advertZone",
  "storageKey": "advertZone(version:2)"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v16 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v17 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "superTopicQueueName"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v18 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": (v22/*: any*/),
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v26 = {
  "alias": "mobileImage",
  "args": [
    {
      "kind": "Literal",
      "name": "type",
      "value": "MOBILE_APP_IMAGE"
    }
  ],
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "300x300"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "style(filter:{\"style\":\"300x300\"})"
    }
  ],
  "storageKey": "image(type:\"MOBILE_APP_IMAGE\")"
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v28 = [
  (v4/*: any*/),
  (v19/*: any*/)
],
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v28/*: any*/),
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v28/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flattenTypeIds",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "LiveArticle",
  "kind": "LinkedField",
  "name": "liveArticle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v28/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "PaywallType",
  "kind": "LinkedField",
  "name": "paywallTypes",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    (v19/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": [
    (v35/*: any*/)
  ],
  "type": "Article",
  "abstractKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    (v33/*: any*/),
    (v36/*: any*/)
  ],
  "type": "Content",
  "abstractKey": "__isContent"
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v39 = [
  (v38/*: any*/),
  (v21/*: any*/)
],
v40 = [
  (v24/*: any*/),
  (v25/*: any*/)
],
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v42 = [
  (v41/*: any*/)
],
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v42/*: any*/),
  "storageKey": null
},
v44 = [
  (v16/*: any*/),
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "applicationIds.0",
            "variableName": "applicationId"
          }
        ],
        "kind": "ListValue",
        "name": "applicationIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "PUBLISHED_DATE"
    }
  }
],
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "Newsletter",
  "kind": "LinkedField",
  "name": "relatedNewsletters",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alternativeName",
      "storageKey": null
    },
    (v43/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "summary",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "homepageDescription",
      "plural": false,
      "selections": (v42/*: any*/),
      "storageKey": null
    },
    (v19/*: any*/)
  ],
  "storageKey": null
},
v46 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "disableFollow",
    "storageKey": null
  }
],
v47 = {
  "kind": "InlineFragment",
  "selections": (v46/*: any*/),
  "type": "Author",
  "abstractKey": null
},
v48 = {
  "kind": "InlineFragment",
  "selections": (v46/*: any*/),
  "type": "Topic",
  "abstractKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Topic",
  "kind": "LinkedField",
  "name": "topics",
  "plural": true,
  "selections": [
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v20/*: any*/),
        (v23/*: any*/),
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    (v19/*: any*/),
    (v45/*: any*/),
    (v15/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortName",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v6/*: any*/),
        (v12/*: any*/),
        (v27/*: any*/),
        (v29/*: any*/),
        (v30/*: any*/),
        (v34/*: any*/),
        (v37/*: any*/),
        (v47/*: any*/),
        (v48/*: any*/)
      ],
      "type": "BaseWithApplicationAndUrlAlias",
      "abstractKey": "__isBaseWithApplicationAndUrlAlias"
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedDate",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readingTime",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headline",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    (v21/*: any*/),
    (v38/*: any*/),
    (v20/*: any*/),
    {
      "alias": "size1200x800",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "1200x800"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "style(filter:{\"style\":\"1200x800\"})"
    },
    {
      "alias": "size540x360",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "540x360"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "style(filter:{\"style\":\"540x360\"})"
    },
    {
      "alias": "landscape250x99",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "style": "landscape_250_99"
          }
        }
      ],
      "concreteType": "ImageStyle",
      "kind": "LinkedField",
      "name": "style",
      "plural": false,
      "selections": (v22/*: any*/),
      "storageKey": "style(filter:{\"style\":\"landscape_250_99\"})"
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "socialHeadline",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flag",
  "storageKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/),
    (v4/*: any*/),
    (v12/*: any*/),
    (v15/*: any*/),
    (v27/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    (v34/*: any*/),
    (v37/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        (v19/*: any*/),
        (v45/*: any*/),
        (v58/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "subHeadline",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortUrl",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seriesShortLabel",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "Article",
  "kind": "LinkedField",
  "name": "seriesContainer",
  "plural": false,
  "selections": [
    (v64/*: any*/),
    (v19/*: any*/),
    (v58/*: any*/)
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sponsorType",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "multimediaEmbed",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "ArticleTypeSegment",
  "kind": "LinkedField",
  "name": "types",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArticleType",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v4/*: any*/),
        (v19/*: any*/),
        (v14/*: any*/),
        (v43/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasVideoContent",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "concreteType": "Author",
  "kind": "LinkedField",
  "name": "authors",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v19/*: any*/),
    (v4/*: any*/)
  ],
  "storageKey": null
},
v72 = [
  (v63/*: any*/)
],
v73 = {
  "kind": "InlineFragment",
  "selections": (v72/*: any*/),
  "type": "Content",
  "abstractKey": "__isContent"
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "duration",
      "storageKey": null
    },
    (v63/*: any*/)
  ],
  "type": "Video",
  "abstractKey": null
},
v75 = [
  (v9/*: any*/),
  (v19/*: any*/)
],
v76 = {
  "kind": "InlineFragment",
  "selections": [
    (v27/*: any*/),
    (v29/*: any*/),
    (v30/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v72/*: any*/),
      "type": "Article",
      "abstractKey": null
    },
    (v73/*: any*/)
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
};
return {
  "fragment": {
    "argumentDefinitions": (v1/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "topicPageQuery",
    "selections": [
      {
        "kind": "InlineDataFragmentSpread",
        "name": "hooksTopicWidgetQuery",
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "topic",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v7/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "topicAdsTopic"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "topicMetadataDisplayTopic"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v8/*: any*/),
            "concreteType": "AppConfig",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
          },
          {
            "alias": "advertConfig",
            "args": (v11/*: any*/),
            "concreteType": "AppConfig",
            "kind": "LinkedField",
            "name": "appConfig",
            "plural": false,
            "selections": (v10/*: any*/),
            "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
          }
        ],
        "args": (v2/*: any*/),
        "argumentDefinitions": [
          (v0/*: any*/)
        ]
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Sponsor",
            "kind": "LinkedField",
            "name": "sponsor",
            "plural": false,
            "selections": [
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v14/*: any*/),
          (v15/*: any*/),
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicDescriptionTopic"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicHeaderTopic"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicRestContentsTopic"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicSeoTopic"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topicTopContentsTopic"
          },
          {
            "args": [
              (v16/*: any*/),
              {
                "kind": "Variable",
                "name": "applicationId",
                "variableName": "applicationId"
              },
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              }
            ],
            "kind": "FragmentSpread",
            "name": "topicTopicPageTopic"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "superTopicQueue",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "helpersCheckIsPlusArticle",
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PaywallType",
                                    "kind": "LinkedField",
                                    "name": "paywallTypes",
                                    "plural": true,
                                    "selections": [
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Article",
                                "abstractKey": null
                              }
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "homeSecondaryContentItemContent"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "sectionTopLeadPrimaryContentItemContent"
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "topStoriesItemContent"
                          }
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:10)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v1/*: any*/),
    "kind": "Operation",
    "name": "topicPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Sponsor",
            "kind": "LinkedField",
            "name": "sponsor",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v19/*: any*/),
              (v14/*: any*/),
              (v20/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ExtraMetadata",
            "kind": "LinkedField",
            "name": "extraMetadata",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Topic",
                "kind": "LinkedField",
                "name": "topic",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v5/*: any*/),
                  (v15/*: any*/),
                  (v26/*: any*/),
                  (v19/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/),
                      (v12/*: any*/),
                      (v27/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v34/*: any*/),
                      (v37/*: any*/)
                    ],
                    "type": "BaseWithApplicationAndUrlAlias",
                    "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AdditionalMetadata",
            "kind": "LinkedField",
            "name": "additionalMetadata",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "propertyType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AdditionalMetadataLogo",
                "kind": "LinkedField",
                "name": "logo",
                "plural": false,
                "selections": (v39/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AdditionalMetadataProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v19/*: any*/),
          (v12/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TopicRelatedLink",
            "kind": "LinkedField",
            "name": "relatedLink",
            "plural": true,
            "selections": (v39/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Topic",
            "kind": "LinkedField",
            "name": "relatedTopics",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v19/*: any*/)
            ],
            "storageKey": null
          },
          (v26/*: any*/),
          (v43/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "chineseName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "OG"
              }
            ],
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": (v22/*: any*/),
            "storageKey": "image(type:\"OG\")"
          },
          {
            "alias": null,
            "args": (v44/*: any*/),
            "concreteType": "ContentConnection",
            "kind": "LinkedField",
            "name": "contents",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isContent"
                      },
                      (v12/*: any*/),
                      (v4/*: any*/),
                      (v15/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      (v51/*: any*/),
                      (v52/*: any*/),
                      (v53/*: any*/),
                      (v54/*: any*/),
                      (v55/*: any*/),
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v61/*: any*/),
                      (v62/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v27/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v63/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v63/*: any*/),
                              (v36/*: any*/)
                            ],
                            "type": "Content",
                            "abstractKey": "__isContent"
                          }
                        ],
                        "type": "BaseWithApplicationAndUrlAlias",
                        "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v35/*: any*/),
                          (v31/*: any*/),
                          (v32/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/),
                          (v66/*: any*/),
                          (v67/*: any*/),
                          (v68/*: any*/),
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v45/*: any*/),
                          (v73/*: any*/)
                        ],
                        "type": "Article",
                        "abstractKey": null
                      },
                      (v74/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v44/*: any*/),
            "filters": [
              "filter",
              "orderBy"
            ],
            "handle": "connection",
            "key": "topicTopicPage__author_contents",
            "kind": "LinkedHandle",
            "name": "contents"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v27/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v34/*: any*/),
              (v37/*: any*/)
            ],
            "type": "BaseWithApplicationAndUrlAlias",
            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "KeyValuePair",
                "kind": "LinkedField",
                "name": "metatags",
                "plural": true,
                "selections": (v40/*: any*/),
                "storageKey": null
              }
            ],
            "type": "DynamicMetaTags",
            "abstractKey": "__isDynamicMetaTags"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v75/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_settings\"})"
      },
      {
        "alias": "advertConfig",
        "args": (v11/*: any*/),
        "concreteType": "AppConfig",
        "kind": "LinkedField",
        "name": "appConfig",
        "plural": false,
        "selections": (v75/*: any*/),
        "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_advert_campaign\"})"
      },
      {
        "alias": "superTopicQueue",
        "args": (v17/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v18/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "QueueItemsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v4/*: any*/),
                          (v15/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          (v54/*: any*/),
                          (v55/*: any*/),
                          (v56/*: any*/),
                          (v57/*: any*/),
                          (v59/*: any*/),
                          (v60/*: any*/),
                          (v61/*: any*/),
                          (v62/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v35/*: any*/),
                              (v31/*: any*/),
                              (v32/*: any*/),
                              (v64/*: any*/),
                              (v65/*: any*/),
                              (v66/*: any*/),
                              (v67/*: any*/),
                              (v68/*: any*/),
                              (v69/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v45/*: any*/),
                              (v76/*: any*/),
                              (v73/*: any*/)
                            ],
                            "type": "Article",
                            "abstractKey": null
                          },
                          (v76/*: any*/),
                          (v74/*: any*/)
                        ],
                        "type": "Content",
                        "abstractKey": "__isContent"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "items(first:10)"
          },
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "afaa9161a81735dbdc47dcb5d5073e61",
    "id": null,
    "metadata": {},
    "name": "topicPageQuery",
    "operationKind": "query",
    "text": "query topicPageQuery(\n  $after: String\n  $applicationId: String!\n  $count: Int = 28\n  $entityId: String!\n  $superTopicQueueName: String!\n) {\n  ...hooksTopicWidgetQuery_49mQWb\n  topic(filter: {entityId: $entityId}) {\n    entityId\n    entityUuid\n    advertZone(version: 2)\n    sponsor {\n      name\n      id\n    }\n    name\n    urlAlias\n    ...hooksTopic\n    ...topicDescriptionTopic\n    ...topicHeaderTopic\n    ...topicRestContentsTopic\n    ...topicSeoTopic\n    ...topicTopContentsTopic\n    ...topicTopicPageTopic_1RYlfy\n    id\n  }\n  superTopicQueue: queue(filter: {name: $superTopicQueueName}) {\n    items(first: 10) {\n      edges {\n        node {\n          __typename\n          ... on Content {\n            __isContent: __typename\n            entityUuid\n            ...helpersCheckIsPlusArticle\n            ...homeSecondaryContentItemContent\n            ...sectionTopLeadPrimaryContentItemContent\n            ...topStoriesItemContent\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment blockquoteQuoteContent on Content {\n  __isContent: __typename\n  ...contentShareWidgetContent\n}\n\nfragment checkersCheckContentContainsStarlingImageContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_2vlzjQ on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size1200x800: style(filter: {style: \"1200x800\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentCoverImageContent_34Njms on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    landscape250x99: style(filter: {style: \"landscape_250_99\"}) {\n      url\n    }\n    size540x360: style(filter: {style: \"540x360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentLiveTagContent on Article {\n  ...helpersCheckHasLiveTagArticle\n}\n\nfragment contentNewsletterWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n    id\n  }\n  sections {\n    value {\n      relatedNewsletters {\n        ...helpersMassageToNewsletterItemNewsletter\n        id\n      }\n      id\n    }\n  }\n  ... on Article {\n    relatedNewsletters {\n      ...helpersMassageToNewsletterItemNewsletter\n      id\n    }\n  }\n}\n\nfragment contentSchemaRenderContent on Content {\n  __isContent: __typename\n  ...blockquoteQuoteContent\n  ...hooksInlinePlusWidgetContent\n  ...imageContent\n  ...inlineWidgetContent\n  ...photoGalleryWidgetContent\n  ...scmpYoutubeContent\n}\n\nfragment contentSectionsContent on Content {\n  __isContent: __typename\n  sections {\n    value {\n      ...helpersCheckIfNewsSectionInFirstIndexSection\n      ...entityLink\n      name\n      id\n    }\n  }\n}\n\nfragment contentSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    ...entityLink\n    seriesContainer {\n      ...entityLink\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment contentShareWidgetContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  shortUrl\n  socialHeadline\n  headline\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSubHeadlineContent on Content {\n  __isContent: __typename\n  subHeadline {\n    json\n  }\n  summary {\n    json\n  }\n  ...contentSchemaRenderContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityFollowButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  ... on Section {\n    entityId\n    name\n  }\n  ... on Author {\n    entityId\n    name\n    disableFollow\n  }\n  ... on Topic {\n    entityId\n    name\n    disableFollow\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment followButtonBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...entityFollowButtonBase\n  entityId\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckHasLiveTagArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckHasSeriesShortLabelContent on Content {\n  __isContent: __typename\n  ... on Article {\n    seriesShortLabel\n    seriesContainer {\n      seriesShortLabel\n      id\n    }\n  }\n}\n\nfragment helpersCheckIfNewsSectionInFirstIndexSection on Section {\n  name\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersMassageToNewsletterItemNewsletter on Newsletter {\n  entityId\n  name\n  alternativeName\n  description {\n    text\n  }\n  summary {\n    text\n  }\n  homepageDescription {\n    text\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment homePrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_3KFgji\n}\n\nfragment homeSecondaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  ...entityLink\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersCheckHasSeriesShortLabelContent\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_1uhIyn\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sections {\n    value {\n      name\n      id\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_1uhIyn on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2vlzjQ\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_2gnGW2 on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSubHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksContentItemProvidersContent_3KFgji on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_2vlzjQ\n  ...contentHeadlineContent\n  ...contentLiveTagContent\n  ...contentSectionsContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ...contentSeriesShortLabelContent\n  ... on Video {\n    __typename\n    ...videoDurationOverlayVideo\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksInlinePlusWidgetContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment hooksTopic on Topic {\n  types\n  sponsor {\n    __typename\n    id\n  }\n}\n\nfragment hooksTopicWidgetQuery_49mQWb on Query {\n  topic(filter: {entityId: $entityId}) {\n    entityId\n    ...hooksTopic\n    ...topicAdsTopic\n    ...topicMetadataDisplayTopic\n    id\n  }\n  appConfig(filter: {entityId: \"scmp_pwa_settings\"}) {\n    json\n    id\n  }\n  advertConfig: appConfig(filter: {entityId: \"scmp_pwa_advert_campaign\"}) {\n    json\n    id\n  }\n}\n\nfragment hooksUseDeepLinkTagsBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  urlAlias\n  entityId\n}\n\nfragment hooksUseDynamicMetaTags on DynamicMetaTags {\n  __isDynamicMetaTags: __typename\n  metatags {\n    key\n    value\n  }\n}\n\nfragment imageContent on Content {\n  __isContent: __typename\n  headline\n  ...checkersCheckContentContainsStarlingImageContent\n}\n\nfragment inlineWidgetContent on Content {\n  __isContent: __typename\n  ...contentNewsletterWidgetContent\n}\n\nfragment photoGalleryDialogContent on Content {\n  __isContent: __typename\n  __typename\n  ...contentShareWidgetContent\n}\n\nfragment photoGalleryWidgetContent on Content {\n  __isContent: __typename\n  ...photoGalleryDialogContent\n}\n\nfragment scmpYoutubeContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  publishedDate\n}\n\nfragment sectionTopLeadPrimaryContentItemContent on Content {\n  __isContent: __typename\n  entityId\n  urlAlias\n  topics {\n    ...followButtonBase\n    id\n  }\n  ...entityLink\n  ...contentCoverImageContent_34Njms\n  ...helpersCheckIsPlusArticle\n  ...helpersCheckHasLiveTagArticle\n  ...helpersUseContentSponsorContent\n  ...hooksContentItemProvidersContent_2gnGW2\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topStoriesItemContent on Content {\n  __isContent: __typename\n  ...homePrimaryContentItemContent\n  ...homeSecondaryContentItemContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment topicAdsTopic on Topic {\n  entityId\n  advertZone(version: 2)\n}\n\nfragment topicDescriptionTopic on Topic {\n  ...topicHeaderRelatedLinksTopic\n  ...entityFollowButtonBase\n  ...hooksTopic\n  ...topicMetadataDisplayTopic\n  extraMetadata {\n    __typename\n  }\n  ...entityLink\n  mobileImage: image(type: MOBILE_APP_IMAGE) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n  name\n  description {\n    text\n  }\n  chineseName\n  sponsor {\n    __typename\n    id\n  }\n}\n\nfragment topicHeaderRelatedLinksTopic on Topic {\n  ...hooksTopic\n  relatedLink {\n    title\n    url\n  }\n  relatedTopics {\n    name\n    urlAlias\n    id\n  }\n}\n\nfragment topicHeaderTopic on Topic {\n  ...topicHeaderRelatedLinksTopic\n  ...entityFollowButtonBase\n  ...hooksTopic\n  ...entityLink\n  mobileImage: image(type: MOBILE_APP_IMAGE) {\n    style(filter: {style: \"300x300\"}) {\n      url\n    }\n  }\n  name\n  chineseName\n  sponsor {\n    ...sponsorTagSponsor\n    id\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n\nfragment topicMetadataDisplayTopic on Topic {\n  ...hooksTopic\n  extraMetadata {\n    key\n    value\n    topic {\n      name\n      ...entityLink\n      types\n      urlAlias\n      mobileImage: image(type: MOBILE_APP_IMAGE) {\n        style(filter: {style: \"300x300\"}) {\n          url\n        }\n      }\n      id\n    }\n  }\n  additionalMetadata {\n    propertyType\n    logo {\n      title\n      url\n    }\n    properties {\n      key\n      value\n    }\n  }\n}\n\nfragment topicRestContentsTopic on Topic {\n  entityId\n  advertZone(version: 2)\n}\n\nfragment topicSeoTopic on Topic {\n  name\n  description {\n    text\n  }\n  entityId\n  urlAlias\n  metaDescription\n  image(type: OG) {\n    url\n  }\n  ...hooksUseDeepLinkTagsBase\n  ...hooksUseDynamicMetaTags\n}\n\nfragment topicTopContentsTopic on Topic {\n  entityId\n  advertZone(version: 2)\n}\n\nfragment topicTopicPageTopic_1RYlfy on Topic {\n  contents(after: $after, first: $count, filter: {applicationIds: [$applicationId]}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        entityUuid\n        ...homeSecondaryContentItemContent\n        ...sectionTopLeadPrimaryContentItemContent\n        ...topStoriesItemContent\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment videoDurationOverlayVideo on Video {\n  duration\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4ae7e86b87c77da9b4334422c14f6238";

export default node;
